/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Capture_Hint_ClothingInputs */

const en_us2_body_assessment_capture_hint_clothing = /** @type {(inputs: Body_Assessment_Capture_Hint_ClothingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tight clothing, so your outline shows.`)
};

const pt_br2_body_assessment_capture_hint_clothing = /** @type {(inputs: Body_Assessment_Capture_Hint_ClothingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roupa justa, para o contorno aparecer.`)
};

const es_419_body_assessment_capture_hint_clothing = /** @type {(inputs: Body_Assessment_Capture_Hint_ClothingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ropa ajustada, para que se vea tu contorno.`)
};

const pt_pt2_body_assessment_capture_hint_clothing = /** @type {(inputs: Body_Assessment_Capture_Hint_ClothingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roupa justa, para se ver o contorno.`)
};

const fr_fr2_body_assessment_capture_hint_clothing = /** @type {(inputs: Body_Assessment_Capture_Hint_ClothingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des vêtements moulants, pour que ta silhouette se voie.`)
};

const de_de2_body_assessment_capture_hint_clothing = /** @type {(inputs: Body_Assessment_Capture_Hint_ClothingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eng anliegende Kleidung, damit deine Umrisse sichtbar sind.`)
};

const it_it2_body_assessment_capture_hint_clothing = /** @type {(inputs: Body_Assessment_Capture_Hint_ClothingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abiti aderenti, così si vede la sagoma.`)
};

/**
* | output |
* | --- |
* | "Tight clothing, so your outline shows." |
*
* @param {Body_Assessment_Capture_Hint_ClothingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_capture_hint_clothing = /** @type {((inputs?: Body_Assessment_Capture_Hint_ClothingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Capture_Hint_ClothingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_capture_hint_clothing(inputs)
	if (locale === "es-419") return es_419_body_assessment_capture_hint_clothing(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_capture_hint_clothing(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_capture_hint_clothing(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_capture_hint_clothing(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_capture_hint_clothing(inputs)
	return en_us2_body_assessment_capture_hint_clothing(inputs)
});
export { body_assessment_capture_hint_clothing as "body-assessment.capture_hint_clothing" }